// src/components/LinkPreview.jsx
import React from 'react';
import { openInAppBrowser } from '../utils/browser';

const LinkPreview = ({ embed }) => {
  if (!embed) return null;

  const handleClick = (e) => {
    e.preventDefault();
    openInAppBrowser(embed.uri);
  };

  const truncateUrl = (url) => {
    try {
      const urlObj = new URL(url);
      return urlObj.hostname + (urlObj.pathname !== '/' ? urlObj.pathname : '');
    } catch {
      return url;
    }
  };

  // Handle thumbnail
  const thumbUrl = embed.thumb?.ref?.$link 
    ? `https://cdn.bsky.app/img/feed_thumbnail/plain/${embed.thumb.ref.$link}@${embed.thumb.mimeType}`
    : null;

  return (
    <button 
      className="link-preview"
      onClick={handleClick}
      type="button"
    >
      {thumbUrl && (
        <div className="link-preview-image">
          <img 
            src={thumbUrl}
            alt={embed.title || 'Link preview'} 
            loading="lazy"
          />
        </div>
      )}
      <div className="link-preview-content">
        {embed.title && (
          <h4 className="link-preview-title">{embed.title}</h4>
        )}
        {embed.description && (
          <p className="link-preview-description">{embed.description}</p>
        )}
        <span className="link-preview-url">
          {truncateUrl(embed.uri)}
        </span>
      </div>
    </button>
  );
};

export default LinkPreview;
